import { render } from "./ApiSettings.vue?vue&type=template&id=767f814e&scoped=true"
import script from "./ApiSettings.vue?vue&type=script&lang=js"
export * from "./ApiSettings.vue?vue&type=script&lang=js"

import "./ApiSettings.vue?vue&type=style&index=0&id=767f814e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767f814e"]])

export default __exports__